"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var withCustomError_1 = __importDefault(require("../helpers/withCustomError"));
var max = function (maxValue) { return function (value) {
    if (value || value === 0) {
        return value > maxValue ? "The value is greater than " + maxValue : undefined;
    }
    return undefined;
}; };
exports.default = (function (maxValue, err) { return withCustomError_1.default(max(maxValue))(err); });
//# sourceMappingURL=max.js.map